import { SetStateAction } from 'react';
import { fetchPackets, abortProtocol } from './Main';
import { Utils } from 'shared/helpers';

/**
 * Function to send a request to fetch data.
 *
 * @param {string} formValues - The form values containing search_packets.
 * @param {string | SetStateAction<string>} searchBy - The searchBy value.
 * @param {string | SetStateAction<string>} sortBy - The sortBy.
 * @param {any} formik - The Formik object with utility functions.
 * @param {number} offset - The offset value.
 * @param {any[]} packetStatus - The packetStatus value.
 * @param {any[]} packetType - The Formik object with utility functions.
 * @param {() => void} callback - callback functions.
 * @returns {Promise<void>} A promise that resolves when the request is completed.
 */
export const sendRequest = async (
    searchByOperator: string,
    searchByBin: string,
    searchByClient: string,
    searchByLoan: string,
    searchByCM9: string,
    searchByuploadDate: string,
    searchBycompletedDate: string,
    SLADaysLeft: number,
    uploadAge: number,
    sortBy: string | SetStateAction<string>,
    formik: any,
    offset: number,
    limit: number,
    packetStatus: any[],
    packetType: any[],
    callback: (
        e: any,
        totalRows: number,
        formik: any,
        isNetworkError: boolean
    ) => void
): Promise<void> => {
    try {
        if (abortProtocol.protocol) {
            abortProtocol.protocol.abort();
        }
        await fetchPackets(
            searchByOperator,
            searchByBin,
            searchByClient,
            searchByLoan,
            searchByCM9,
            searchByuploadDate,
            searchBycompletedDate,
            SLADaysLeft,
            uploadAge,
            sortBy,
            offset,
            limit,
            packetStatus,
            packetType,
            (e: any[], totalRows: number, isNetworkError: boolean) =>
                callback(e, totalRows, formik, isNetworkError)
        );
    } catch (error: any) {
        if (error.message === 'Network Error') {
            if (formik) {
                formik.setSubmitting(false);
            }
        } else {
            Utils.handleErrorResponse(error);
            if (formik) {
                formik.setSubmitting(false);
            }
        }
    }
};
